import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed, onBeforeUnmount, ref } from 'vue';
import WorkerDetail from '@/views/Dialog/WorkerDetail/index.vue';
import vuexStore from '@/vuex-store';
import { workerActionType } from '@/vuex-store/worker/actions';
import { modalWorkerInfoActionType } from '@/vuex-store/modal-worker-info/actions';
// WorkerDetail 컴포넌트의 ref를 생성하여 expose된 속성에 접근
export default /*@__PURE__*/ _defineComponent({
    __name: 'ModalWorkerInfo2',
    setup(__props) {
        // PAGE: 라이더 상세 정보 v2 버전
        const workerDetailRef = ref();
        const isOpenModalWorkerInfo = computed(() => vuexStore.state.modalWorkerInfo.isOpenModalWorkerInfo);
        const workerData = computed(() => vuexStore.state.worker.worker);
        const workerCode = computed(() => workerData.value?.code);
        const isOpen = computed({
            get() {
                return !!isOpenModalWorkerInfo.value;
            },
            set() {
                if (!workerDetailRef.value?.handleClickCloseBtn()) {
                    return;
                }
                vuexStore.dispatch(modalWorkerInfoActionType.setIsOpenModalWorkerInfo, 0);
                vuexStore.dispatch(workerActionType.clearWorker);
            },
        });
        // onCreated
        const unWatch = vuexStore.watch((state) => state.modalWorkerInfo.isOpenModalWorkerInfo, (_workerCode) => {
            if (!_workerCode) {
                return true;
            }
            return vuexStore.dispatch(workerActionType.getWorker, {
                workerCode: _workerCode,
            });
        });
        onBeforeUnmount(() => {
            unWatch();
        });
        return (_ctx, _cache) => {
            const _component_v_dialog = _resolveComponent("v-dialog");
            return (_openBlock(), _createBlock(_component_v_dialog, {
                modelValue: isOpen.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isOpen).value = $event)),
                "content-class": "modal",
                width: "1450"
            }, {
                default: _withCtx(() => [
                    _createVNode(WorkerDetail, {
                        ref_key: "workerDetailRef",
                        ref: workerDetailRef,
                        "props-worker-code": workerCode.value
                    }, null, 8 /* PROPS */, ["props-worker-code"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"]));
        };
    }
});
